import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { BidderCompanyProfileForm } from '@/components/auth/bidder-company-form';
import { BidderRoleGate } from '@/components/auth/bidder-role-gate';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_app/profile/bidder/company')({
  component: BidderCompanyProfilePage,
});

function BidderCompanyProfilePage(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Profil Bidder Société"
        subtitle="Renseignez les informations de votre société, les compétences agrégées, les langues maîtrisées par l'équipe et l'identifiant légal."
      />
      <BidderRoleGate bidderType="COMPANY">
        <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)] md:p-8">
          <BidderCompanyProfileForm />
        </section>
      </BidderRoleGate>
    </div>
  );
}
